module.exports = {"130131100":"平山镇","130131101":"东回舍镇","130131102":"温塘镇","130131103":"南甸镇","130131104":"岗南镇","130131105":"古月镇","130131106":"下槐镇","130131107":"孟家庄镇","130131108":"小觉镇","130131109":"蛟潭庄镇","130131110":"西柏坡镇","130131111":"下口镇","130131200":"西大吾乡","130131201":"上三汲乡","130131202":"两河乡","130131203":"东王坡乡","130131204":"苏家庄乡","130131205":"宅北乡","130131207":"北冶乡","130131209":"上观音堂乡","130131210":"杨家桥乡","130131211":"营里乡","130131212":"合河口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130131.json
// module id = 158
// module chunks = 0